import moment from 'moment';
import { useCookies } from 'react-cookie';

import ROUTES from 'constants/routes';

export const AUTH_COOKIE_KEY = 'BEARER';

export const DAYS_DELAY = 'days';
export const HOURS_DELAY = 'hours';

const EXPIRES_BY_DELAY = {
  [DAYS_DELAY]: 10,
  [HOURS_DELAY]: 1,
};

export default function useAuthToken() {
  const [cookie, setCookie] = useCookies([AUTH_COOKIE_KEY]);
  return {
    cookie,
    setCookie: (
      token: string,
      expires: keyof typeof EXPIRES_BY_DELAY = DAYS_DELAY,
    ) => {
      setCookie(AUTH_COOKIE_KEY, token, {
        path: ROUTES.HOME,
        expires: moment().add(EXPIRES_BY_DELAY[expires], DAYS_DELAY).toDate(),
      });
    },
  };
}
